import { Box, Text } from '@chakra-ui/react';
import type React from 'react';

export interface FaceliftSelectProps {
	topLabel?: string;
	required?: boolean;
	error?: string;
	options: { value: string; label: string; disabled?: boolean }[];
	value?: string[];
	onValueChange?: (details: { value: string[] }) => void;
	placeholder?: string;
}

const FaceliftSelect: React.FC<FaceliftSelectProps> = ({
	topLabel,
	required,
	error,
	options,
	value,
	onValueChange,
	placeholder,
}) => {
	const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedValue = e.target.value;
		onValueChange?.({ value: [selectedValue] });
	};

	return (
		<Box>
			{topLabel && (
				<Text fontSize="sm" fontWeight="medium" color="brand.input.text" mb={2}>
					{topLabel}
					{required && (
						<Text as="span" color="brand.errors">
							*
						</Text>
					)}
				</Text>
			)}
			<select
				value={value?.[0] || ''}
				onChange={handleChange}
				style={{
					borderTop: 'none',
					borderLeft: 'none',
					borderRight: 'none',
					borderBottom: '2px solid',
					borderImage:
						'linear-gradient(90deg, var(--chakra-colors-brand-500) 0%, var(--chakra-colors-brand-600) 100%) 1',
					borderRadius: 'none',
					background: 'var(--chakra-colors-brand-input-bg)',
					color: 'var(--chakra-colors-brand-input-text)',
					paddingLeft: 0,
					paddingRight: 0,
					paddingTop: '4px',
					paddingBottom: '4px',
					width: '100%',
					fontSize: '14px',
					height: '40px',
					boxSizing: 'border-box',
					display: 'flex',
					alignItems: 'center',
					transform: 'translateY(-1px)',
				}}
			>
				{placeholder && (
					<option value="" disabled>
						{placeholder}
					</option>
				)}
				{options.map((option) => (
					<option
						key={option.value}
						value={option.value}
						disabled={option.disabled}
					>
						{option.label}
					</option>
				))}
			</select>
			{error && (
				<Text color="brand.errors" fontSize="sm" mt={1}>
					{error}
				</Text>
			)}
		</Box>
	);
};

export default FaceliftSelect;
